import { render, staticRenderFns } from "./BdDevice.vue?vue&type=template&id=7ec6423c&scoped=true&"
import script from "./BdDevice.vue?vue&type=script&lang=js&"
export * from "./BdDevice.vue?vue&type=script&lang=js&"
import style0 from "./BdDevice.vue?vue&type=style&index=0&id=7ec6423c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec6423c",
  null
  
)

export default component.exports